import { useAtom } from "jotai";
import { zIndexLevel } from "src/utils/zIndexLevels";
import styled from "styled-components";

import { Toast } from "./components/Toast";
import { toastsAtom } from "./store/atoms";
import { Flex } from "src/elements";
import { useEffect, useRef } from "react";

const ToastsContainer = styled(Flex)`
  flex-direction: column;
  position: fixed;
  bottom: 10px;
  left: 10px;
  z-index: ${zIndexLevel.TOASTS};
`;

export const Toasts = () => {
  const [toasts, setToasts] = useAtom(toastsAtom);
  const refTimeoutCleanup = useRef<NodeJS.Timeout>(null);

  // Effect to cleanup all toasts.
  useEffect(() => {
    if (toasts.length > 0) {
      if (toasts.find((toast) => toast.state === "OPEN")) {
        if (refTimeoutCleanup.current) {
          clearTimeout(refTimeoutCleanup.current);
        }
      } else {
        refTimeoutCleanup.current = setTimeout(() => {
          setToasts([]);
        }, 1000);
      }
    }
  }, [toasts]);

  return (
    <ToastsContainer>
      {toasts.map((toast, i) => (
        <Toast key={i} toast={toast} />
      ))}
    </ToastsContainer>
  );
};
